import { FC } from 'react'
import { observer } from 'mobx-react'
import InformationForm from './InformationForm'

const CollectingForm: FC<unknown> = () => {
  return <InformationForm variant={'collecting'} />
}
export default observer(CollectingForm)
